export const UPDATE_HEALTH_QUESTIONNAIRE_ACTION = 'UpdateHealthQuestionnaire'
export const UPDATE_TODAY_HEALTH_CONDITION = 'UpdateTodayHealthCondition'


// WEBPACK FOOTER //
// ./src/constants/loginOptionalActions.js